export default __webpack_public_path__ + "static/media/yoripe-logo.d3e2132d.png";